export default "__VITE_ASSET__BsWpFpvP__"